import React from "react"
import classnames from "classnames"
import styles from "./Content.less"

class Content extends React.PureComponent {
  _handleOnClick = () => {
    const { onClick = () => { } } = this.props
    onClick()
  }

  render() {
    let {
      children, xmlString, replaceVariables, textAlign, textAlignMobile, theme
    } = this.props

    let content = replaceVariables
      ? Object.entries(replaceVariables).reduce((string, [key, value]) =>
        string.replace(`$${key}$`, value || ""), xmlString)
      : xmlString

    if (
      content && (
        content.indexOf('white;') > -1
        || content.indexOf('#ffffff') > -1
        || content.indexOf('#fff') > -1
        || content.indexOf('#FFFFFF') > -1
        || content.indexOf('#e7e7e7') > -1
      )
    ) {
      theme = 'dark'
    }

    if (content)
      content.replace(`/<p>&nbsp;</p>/g`, '')

    if ( content && content.indexOf('#000000') > -1 ) {
      theme = 'light'
      content = content.replace('#000000', '#101010')
    }

    return (
      <div
        className={classnames({
          [styles.Content]: true,
          [styles.ContentLeft]: textAlign == "left",
          [styles.ContentRight]: textAlign == "right",
          [styles.ContentMobileCenter]: textAlignMobile == "center",
          [styles.ContentMobileLeft]: textAlignMobile == "left",
          [styles.ContentMobileRight]: textAlignMobile == "right",
          [styles.ContentDark]: theme === 'dark'
        })}
        data-test="wysiwyg"
        dangerouslySetInnerHTML={children ? undefined : { __html: content }}>
        {children}
      </div>
    )
  }
}


export default Content



// WEBPACK FOOTER //
// ./src/AtomicComponents/Content/Content.jsx